import { getPagePath, trans } from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';
import { Button, ValuePropositionFeatures } from '@spotahome/ui-library';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import { DSIcon } from '@spotahome/ui-library/base';

import { SHOW_EXTENDED_LANDLORD_INFORMATION } from '@spotahome/marketplace-common/src/channels';

import { useLandlordInformation } from '../../context/LandlordInformationContext';

import { ListingSectionObservable } from '../ListingSection';
import ListingTitle from '../ListingTitle';

import './CancellationPolicies.scss';

export const CancellationPolicies = () => {
  const { landlordInformation } = useLandlordInformation();
  const seeMoreClickHandler = () => {
    SoyuzAnalytics.sendGA4Event('CancellationPolicies', {
      action: 'SeeMore'
    });
  };

  const handleLandlordTypeClick = () => {
    Mediator.publish(SHOW_EXTENDED_LANDLORD_INFORMATION);
  };

  return (
    <ListingSectionObservable section="cancellationPolicies">
      <ListingTitle role="secondary">
        {trans('cancellation.policies.title')}
      </ListingTitle>

      <div className="cancellation-policies-container">
        <div className="cancellation-policies-container__policies">
          <div className="cancellation-policies-container__policy">
            <DSIcon
              name="more_horiz_circle"
              className="cancellation-policies-container__policy-icon"
            />
            <div>
              {trans('cancellation.policies.before.landlord.accepts')} -{' '}
              <strong>
                {trans('cancellation.policies.nothing.will.be.charged')}
              </strong>
            </div>
          </div>
          <div className="cancellation-policies-container__policy">
            <DSIcon
              name="check_circle"
              className="cancellation-policies-container__policy-icon"
            />
            <div>{trans('cancellation.policies.after.landlord.accepts')}</div>
          </div>
          <ul className="cancellation-policies-container__policy-days">
            <li>{trans('cancellation.policies.60.days.before')}</li>
            <li>{trans('cancellation.policies.30.days.before')}</li>
            <li>{trans('cancellation.policies.on.move.in')}</li>
          </ul>
          <Button
            onClick={seeMoreClickHandler}
            className="cancellation-policies-container__link"
            color="link"
            href={getPagePath('help-center.cancellation-policies')}
            target="_blank"
          >
            {trans('cancellation.policies.read.more')}
          </Button>
          <div className="cancellation-policies-container__fee-warning">
            {trans('cancellation.policies.fee.warning')}
          </div>
        </div>
        <ValuePropositionFeatures
          title={trans('cancellation.policies.value.proposition.title')}
          className="cancellation-policies-container__value-proposition"
          isChecked={false}
          hasNoDeposit={false}
          isInstantBookingEnabled={false}
          backgroundColor="white"
          landlordInformation={landlordInformation}
          onLandlordTypeClick={handleLandlordTypeClick}
        />
      </div>
    </ListingSectionObservable>
  );
};

export default CancellationPolicies;
